namespace SolovisGateway.Admin.Organizations {

    export interface OrgInviteUserDialogOptions {
        organizationId?: number;        
    }

    export class OrgInviteUserDialog {

        private _options: OrgInviteUserDialogOptions;

        private _formBuilder: Solovis.UI.InputControls.FormBuilder;
        private _dialog: Solovis.UI.Dialog;

        constructor(options: OrgInviteUserDialogOptions) {
            this._options = options;
        }

        public show() {
            let formBuilderDiv = $("<div>");
            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formBuilderDiv                
            });
            this._formBuilder = formBuilder;

            let helpText = "User will receive an email invitiation to set the password for their new Solovis account. This account"
                + " will not be part of your organization user list.";

            formBuilder.addEntry({
                name: "help",
                label: null,

                hideLabelElement: true,
                showValueOnFullRow: true,

                createEditor: (editorOptions) => {
                    $("<p>").text(helpText).appendTo(editorOptions.container);

                    return {
                        getValue: () => { return null; }
                    };
                },                
            });

            formBuilder.addEntry({
                name: "fullName",
                label: "Full Name",

                editor: {
                    type: "text",

                    required: true
                }
            });

            formBuilder.addEntry({
                name: "email",
                label: "Email",

                editor: {
                    type: "text",

                    required: true
                }
            });

            formBuilder.addEntry({
                name: "note",
                label: "Note",

                editor: {
                    type: "textarea"
                }
            });

            formBuilder.setupDone();

            this._dialog = formBuilder.showAsDialog({
                title: "Invite User",

                desiredWidth: 600,
                desiredHeight: 400,

                showSaveCancel: true,

                saveCallback: () => {
                    if (!formBuilder.hasErrors()) {
                        this._saveAsync();
                    }

                    return false;
                }
            });
        }

        private async _saveAsync(): Promise<void> {
            let fullName = this._formBuilder.getValueByName("fullName");
            let email = this._formBuilder.getValueByName("email");
            let note = this._formBuilder.getValueByName("note");

            let response = await Solovis.Rpc.invokeAndWait(
                "~/Organization/InviteNonOrgUser",
                {
                    organizationId: this._options.organizationId,
                    fullName: fullName,
                    email: email,
                    note: note
                });

            let modelState = response.result;
            if (modelState) {
                if (modelState.modelIsValid) {
                    this._dialog.close();
                    Solovis.UI.alert($("<p>").text(fullName + " has been invited."), "New Account Invitation Sent");
                }
                else {
                    this._formBuilder.applyErrors(modelState.errors);
                }
            }
        }
    }

}